export default __webpack_public_path__ + "static/media/HallmarkChannelLogo.9e2adaab.svg";